import React from "react";
import { withTranslation } from "react-i18next";
import { BootstrapModal } from "../CommonComponents";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

import {
  showModal,
  hideModal,
  nameUpdate,
  nameUpdateClear,
  logoutUser,
} from "../../common/actions/userAccount";
import {
  accountDelete,
  accountDeleteClear,
} from "../../common/actions/userAccount/userAccountAction";
import { createLoadingSelector } from "../../common/reducers/selectors";
const loadingSelector = createLoadingSelector(["update_name"]);

class ViewProfile extends React.Component {
  constructor(props) {
    super(props);
    const { userLoginInfo } = this.props;
    this.state = {
      enableEditName: true,
      userName: userLoginInfo.firstName + " " + userLoginInfo.lastName,
      userInitials:
        userLoginInfo.firstName.charAt(0) + userLoginInfo.lastName.charAt(0),
      userPhone: userLoginInfo.CountryCode + userLoginInfo.mobile,
      avatarSource: null,
      userEmail: "",
      firstNameInvalid: "",
      lastNameInvalid: "",
      firstName: userLoginInfo.firstName,
      lastName: userLoginInfo.lastName,
      firstNameError: "",
      lastNameError: "",

      password: "",
      email: "",
      askVerification: false,
      isValidEmail: false,
      isValidPassword: false,
      emailInvalid: "",
      passwordInvalid: "",
    };
  }
  loadUpdates = () => {
    const { userLoginInfo } = this.props;
    this.setState({
      userName: userLoginInfo.firstName + " " + userLoginInfo.lastName,
      userInitials:
        userLoginInfo.firstName.charAt(0) + userLoginInfo.lastName.charAt(0),
    });
  };

  secondTextInput(event) {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    if (event.key === "Enter") {
      form.elements[index + 1].focus();
    }
  }

  handleFirstNameChange = ({ target: { value: firstName } }) =>
    this.setState({ firstName, firstNameError: "" });
  handleLastNameChange = ({ target: { value: lastName } }) =>
    this.setState({ lastName, lastNameError: "" });

  submitForm = () => {
    const { firstName, lastName } = this.state;
    const { doNameUpdate } = this.props;

    if (firstName.trim() === "") {
      this.setState({ firstNameError: this.props.t("First_Name_Alert") });
      return;
    }
    if (lastName.trim() === "") {
      this.setState({ lastNameError: this.props.t("Last_Name_Alert") });
      return;
    }

    doNameUpdate({ firstName, lastName });
  };

  submitDeleteAccount = ({ onClose }) => {
    const { email, password } = this.state;
    const { doDeleteAccount } = this.props;
    if (email === "" || email === null) {
      this.setState({ emailInvalid: this.props.t("Email_Alert") });
      return;
    }
    if (password === "" || password === null) {
      this.setState({ passwordInvalid: this.props.t("Password_Alert") });
      return;
    }

    
    doDeleteAccount({
      email: email,
      password: password,
    });
    onClose();
    this.setState({ askVerification: false });

    // if (isValidEmail === false && isValidPassword === true) {
    //   alert('field is not valid')
    //   this.setState({ passwordInput: translate("Password_Alert") });
    //   return
    // } else {
    //   doDeleteAccount({
    //     email: email,
    //     password: password,
    //   })
    // }
  };
  showPasswordOptions = () => {
    const {
      email,
      password,
      isValidEmail,
      isValidPassword,
      emailInvalid,
      passwordInvalid,
    } = this.state;

    return confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <div className="react-confirm-alert">
              <div className="react-confirm-alert-body">
                <form className="form-style1 text-left">
                  <p>
                    <label className="control-label">
                      {this.props.t("delete_account_alert")}
                    </label>
                  </p>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={this.props.t("loginScreen-email")}
                      onKeyPress={(event) => this.secondTextInput(event)}
                      // value={email}
                      onChange={(event) => {
                        this.setState({ email: event.target.value });
                        if (event.target.value === "") {
                          this.setState({
                            emailInvalid: this.props.t("Email_Alert"),
                          });
                        } else {
                          this.setState({ emailInvalid: "" });
                        }
                      }}
                    />
                    <span className="error"> {emailInvalid}</span>
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      name="PasswordRequiredForChange"
                      placeholder={this.props.t("loginScreen-password")}
                      onChange={(event) => {
                        this.setState({ password: event.target.value });
                        if (event.target.value === "") {
                          this.setState({
                            passwordInvalid: this.props.t("Password_Alert"),
                          });
                        } else {
                          this.setState({ passwordInvalid: "" });
                        }
                      }}
                      // value={val}
                    />
                    <span className="error"> {passwordInvalid}</span>
                  </div>
                  <div className="react-confirm-alert-button-group">
                    <button
                      type="button"
                      onClick={() => {
                        // this.setState({ askVerification: false });
                        this.submitDeleteAccount({ onClose });
                      }}
                    >
                      {this.props.t("DELETE")}
                    </button>
                    <button
                      className="cancel-btn"
                      onClick={(event) => {
                        event.preventDefault();
                        onClose();
                        this.setState({ askVerification: false });
                      }}
                    >
                      {this.props.t("regNameScr-cancel")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  deleteAccountConfirm = () => {
    confirmAlert({
      title: this.props.t("delete_account"),
      message: this.props.t("deleteaccount-areYouSuretext"),
      buttons: [
        {
          label: this.props.t("settingMainScr-ok"),
          onClick: this.deleteAccount,
        },
        {
          label: this.props.t("Cancel"),
          className: "cancel-btn",
        },
      ],
    });
  };
  deleteAccountTapped = () => {
    this.setState({ askVerification: true });
  };
  validate = (text) => {
    // const { isValidEmail, emailInvalid } = this.state;
    // let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
    // console.log("text====", text);
    // if (text === "") {
    //   this.setState({
    //     isValidEmail: false,
    //     emailInvalid: this.props.t("Email_Alert"),
    //   });
    //   //this.setState({ emailInvalid: this.props.t("Email_Alert") });
    //   console.log("email blank ", isValidEmail);
    // } 
    // else if (reg.test(text) === false) {
    //   this.setState({ email: text, isValidEmail: false });
    //   console.log("email not verified ", isValidEmail);
    //   this.setState({ emailInvalid: this.props.t("Email_Invalid_Alert") });
    // } else {
    //   this.setState({ email: text, isValidEmail: true });
    //   console.log("email verified ", isValidEmail);
    // }
  };

  componentDidUpdate() {
    const {
      updateNameResponse,
      error,
      doNameUpdateClear,
      deleteAccount,
      doDeleteAccountClear,
    } = this.props;
    if (error) {
      toast.error(error.Message || error.Message, {
        autoClose: 2000,
        transition: Slide,
        hideProgressBar: true,
      });

      doNameUpdateClear();
    } else if (updateNameResponse) {
      toast.success(updateNameResponse.Message || updateNameResponse.Message, {
        autoClose: 2000,
        transition: Slide,
        hideProgressBar: true,
      });

      doNameUpdateClear();
      this.setState({ enableEditName: !this.state.enableEditName });
      this.loadUpdates();
    }

    console.log("Delete account msg ", deleteAccount);
    if (deleteAccount != null) {
      if (deleteAccount.Success) {
        toast.success(deleteAccount.Message, {
          autoClose: 2000,
          transition: Slide,
          hideProgressBar: true,
        });
        this.setState({ askVerification: false }, () => {
          this.props.doLogoutUser();
          //QuickActions.clearShortcutItems();
          this.props.history.push("/");
        });
      } else {
        toast.error(deleteAccount.Message, {
          autoClose: 2000,
          transition: Slide,
          hideProgressBar: true,
        });
      }
      doDeleteAccountClear();
    }
  }

  renderViewProfile = () => {
    const {
      userName,
      userPhone,
      userInitials,
      avatarSource,
      firstNameInvalid,
      lastNameInvalid,
      firstNameError,
      lastNameError,
      firstName,
      lastName,
      enableEditName,
      askVerification,
    } = this.state;

    const { isFetching, registeredEmail } = this.props;
    console.log("askVerification", askVerification);

    return (
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="popup-header">
            <button
              type="button"
              className="close-btn pull-right"
              onClick={() => {
                this.closeModal();
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div className="profileDetails">
              <div className="profile-image">
                <span className="noimage">{userInitials}</span>
              </div>

              <div className="username">
                <h4>
                  <span>{userName}</span>
                  <button
                    type="button"
                    className="btn profile-edit"
                    onClick={() => {
                      this.setState({ enableEditName: true });
                    }}
                  >
                    <i className="fas fa-user-edit"></i>
                  </button>
                </h4>
              </div>
              <div className="user-otherinfo">
                <p>{userPhone}</p>
                <p>
                  <a href={"mailto:" + registeredEmail}>{registeredEmail}</a>
                </p>
              </div>
            </div>
            {enableEditName === true && (
              <div className="form-card">
                <form className="form-style1">
                  <div className="form-group">
                    <input
                      type="text"
                      className={`form-control ${
                        firstNameError !== "" ? "input-error" : null
                      }`}
                      placeholder={this.props.t("regNameScr-firstName")}
                      value={firstName}
                      name="firstName"
                      maxLength={30}
                      onChange={this.handleFirstNameChange}
                      onKeyPress={(event) => this.secondTextInput(event)}
                    />
                    <span className="error"> {firstNameError}</span>
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      className={`form-control ${
                        lastNameError !== "" ? "input-error" : null
                      }`}
                      placeholder={this.props.t("regNameScr-lastName")}
                      value={lastName}
                      name="lastName"
                      onChange={this.handleLastNameChange}
                      maxLength={30}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") this.submitForm();
                      }}
                    />
                    <span className="error"> {lastNameError}</span>
                  </div>
                  <div className="btn-sect">
                    <button
                      type="button"
                      className="btn  btn-default"
                      onClick={this.submitForm}
                    >
                      {isFetching ? (
                        <i className="fas fa-sync-alt fa-spin"></i>
                      ) : null}{" "}
                      {this.props.t("changePickupScr-save")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-default btn-red"
                      onClick={() => {
                        this.setState({ enableEditName: false });
                      }}
                    >
                      {this.props.t("editChildScr-cancel")}
                    </button>
                  </div>
                </form>
              </div>
            )}
            <div className="delete-account-sect pdt-20">
              <button
                type="button"
                className="btn btn-action red-text delete-acount-btn"
                onClick={() => {
                  this.deleteAccountTapped();
                }}
              >
                <i className="fas fa-trash-alt mr-5px"></i>
                <span className="text">{this.props.t("deleteAccount")}</span>
              </button>
            </div>
            {askVerification && this.showPasswordOptions()}
          </div>
        </div>
      </div>
    );
  };
  closeModal = () => {
    this.props.doHideModal();
  };

  render() {
    return this.renderViewProfile();
  }
}

function mapStateToProps(state) {
  return {
    userLoginInfo: state.userAccount.userLoginInfo,
    registeredEmail: state.userAccount.registeredEmail,
    deleteAccount: state.userAccount.deleteAccount,
    isFetching: loadingSelector(state),
    updateNameResponse: state.userAccount.updateNameResponse,
    error: state.userAccount.error,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    doShowModal: (data) => dispatch(showModal(data)),
    doHideModal: () => dispatch(hideModal()),
    doNameUpdate: (data) => dispatch(nameUpdate(data)),
    doNameUpdateClear: () => dispatch(nameUpdateClear()),
    doLogoutUser: () => dispatch(logoutUser()),
    doDeleteAccount: (data) => dispatch(accountDelete(data)),
    doDeleteAccountClear: () => dispatch(accountDeleteClear()),
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewProfile))
);
